<template>
  <div v-show="isLoaded">
    <b-button
      v-if="hasData"
      class="mt-5"
      variant="outline-primary"
      v-on:click="createExcel"
      >Download</b-button
    >
    <p v-else class="mt-5">
      No primary school learner data available to download.
    </p>
  </div>
</template>

<script>
import ExcelJS from "exceljs";
import router from "@/router";
import PrimarySchoolService from "../services/PrimarySchoolService";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MEExport",
  data() {
    return {
      isLoaded: false,
      hasData: false,
      leanerData: []
    };
  },

  methods: {
    createExcel() {
      const workbook = new ExcelJS.Workbook();
      workbook.creator = "Perivoli";
      workbook.created = new Date();
      workbook.modified = new Date();

      const worksheet = workbook.addWorksheet("Primary School Leaner Data");

      worksheet.addRow([
        "student_uuid",
        "student_name",
        "date",
        "attendance",
        "drop_out",
        "score_maths",
        "score_english",
        "score_art",
        "score_overall",
        "rank_in_class",
        "number_on_role",
        "held_back",
        "additional_notes",
        "updated_at",
        "created_at",
        "school_name",
        "teacher_name",
        "teacher_signed",
        "head_teacher_signed",
        "grade",
        "number_pupils_in_class",
        "trainer"
      ]);

      for (const input of this.leanerData) {
        worksheet.addRow([
          input["student_uuid"],
          input["student_name"],
          input["date"],
          input["attendance"],
          input["drop_out"],
          input["score_maths"],
          input["score_english"],
          input["score_art"],
          input["score_overall"],
          input["rank_in_class"],
          input["number_on_role"],
          input["held_back"],
          input["additional_notes"],
          input["updated_at"],
          input["created_at"],
          input["school_name"],
          input["teacher_name"],
          input["teacher_signed"],
          input["head_teacher_signed"],
          input["grade"],
          input["number_pupils_in_class"],
          input["trainer"]
        ]);
      }

      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadworksheetml.worksheet"
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = "primary-school-leaner-data.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    },
    showOptions() {
      if (this.leanerData.length > 0) {
        this.hasData = true;
      }
    },
    async LoadData() {
      const res = await PrimarySchoolService.getPrimarySchoolLeanerData(
        router.currentRoute.params.id
      );
      const data = res.data.result;
      this.leanerData = data;
    }
  },
  async created() {
    await this.LoadData();
    this.isLoaded = true;
    this.showOptions();
  }
};
</script>   